/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import actions from "./actions"
import Vue from "@/entry/setupVue3.js";

const state = {
	invoiceList: [],
	invoiceListPager: null
}

const getters = {
	invoiceList( state ) {
		return state.invoiceList;
	},
}

const mutations = {
	SET_INVOICE_LIST(state, invoiceList) {
		state.invoiceList = invoiceList;
	},
	UPDATE_INVOICE_ITEM_IN_LIST(state, invoice) {
		let index = state.invoiceList.findIndex(item => item.id == invoice.id)
		Vue.set(state.invoiceList, index, invoice);
	},
	DELETE_INVOICE_ITEM_IN_LIST(state, invoice) {
		let index = state.invoiceList.findIndex(item => item.id == invoice.id)
		Vue.delete(state.invoiceList, index);
	},
}
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
